import React from 'react'
import { semFoto } from '../../../assets/'
import { Box } from '@mui/material'
import { Services } from '../../../services'
import RouterHook from '../../../contexts/RouterHook'
import { BttPix } from '..'

export default function CompInfo({ mode, pedido }) {
  const serverRouter = RouterHook()

  function SearchCountry() {
    Services.SearchCountry(pedido.quadra.endereco, pedido.empresa.username, pedido.empresa.nome)
  }

  function StartGoPix() {
    serverRouter('pay-pix', pedido.idpagamento)
  }

  if (mode === 1) {
    return (
      <div className='componente-de-informacao'>
        <h2>PAGAMENTO</h2>
        <div className='componente-de-informacao-line'>
          <p>Forma de pagamento</p>
          <h3>{Services.ReturnMetodoPay(pedido.formaPagamento)}</h3>
        </div>
        {pedido.valorDesconto > 0 ? (
          <div className='componente-de-informacao-line'>
            <p style={{ textDecoration: 'line-through' }}>Valor Total</p>
            <p style={{ textDecoration: 'line-through' }}>
              {Services.FormatValor(pedido.valorTotal || 0)}
            </p>
          </div>
        ) : (
          <div className='componente-de-informacao-line'>
            <p>Valor Total</p>
            <h3>R${pedido.valorTotal.toFixed(2).toString().replace('.', ',')}</h3>
          </div>
        )}
        {pedido.valorDesconto > 0 && (
          <div className='componente-de-informacao-line'>
            <p>Valor Desconto</p>
            <h3>R${pedido.valorDesconto.toFixed(2).toString().replace('.', ',')}</h3>
          </div>
        )}
        {pedido.valorPendente > 0 && pedido.status !== 'CANCELADO' && (
          <div className='componente-de-informacao-line'>
            <p>Valor Pendente</p>
            <h3 style={{ color: '#edb201' }}>
              R$
              {pedido.valorPendente.toFixed(2).toString().replace('.', ',')}
            </h3>
          </div>
        )}
        {pedido.valorDesconto > 0 && (
          <div className='componente-de-informacao-line'>
            <p>Valor Total com Desconto</p>
            <h3>
              R$
              {(pedido.valorTotal - pedido.valorDesconto).toFixed(2).toString().replace('.', ',')}
            </h3>
          </div>
        )}

        {pedido.valorRealizado > 0 && pedido.status !== 'CANCELADO' && (
          <div className='componente-de-informacao-line'>
            <p>Valor Pago</p>
            <h3 style={{ color: '#24ad49' }}>
              R$
              {pedido.valorRealizado.toFixed(2).toString().replace('.', ',')}
            </h3>
          </div>
        )}
        {pedido.valorEstornado > 0 && (
          <div className='componente-de-informacao-line'>
            <p>Valor Estornado</p>
            <h3 style={{ color: '#be3223' }}>
              R$
              {pedido.valorEstornado.toFixed(2).toString().replace('.', ',')}
            </h3>
          </div>
        )}
        {pedido.valorRealizado > 0 && pedido.status === 'CANCELADO' && (
          <div className='componente-de-informacao-line'>
            <p>Multa por cancelamento</p>
            <h3 style={{ color: '#be3223' }}>
              R$
              {pedido.valorRealizado.toFixed(2).toString().replace('.', ',')}
            </h3>
          </div>
        )}
        {pedido.status === 'SOLICITADO' && pedido.formaPagamento === 'PIX' ? (
          <BttPix
            onClick={() => {
              StartGoPix()
            }}
            text={'Ver código PIX'}
          />
        ) : (
          <></>
        )}
      </div>
    )
  } else {
    return (
      <div className='componente-de-informacao'>
        <h2>LOCAL</h2>
        <div className='contain-pedido-local-quadra'>
          <button
            className='contain-pedido-local-quadra-button'
            onClick={() => {
              SearchCountry()
            }}
          >
            <img
              alt='Imagem da quadra'
              src={'' + pedido.quadra.urlFoto + pedido.quadra.foto}
              onError={e => {
                // setar a imagem padrão caso ocorra erro no carregamento
                e.target.onerror = null // evita loop infinito
                e.target.src = semFoto
              }}
            />
          </button>

          <div className='contain-infos-quadra'>
            <h2>{pedido.empresa.nome}</h2>
            <h3>{pedido.quadra.descricao}</h3>
            <h4 title={pedido.quadra.endereco.length > 46 ? pedido.quadra.endereco : ''}>
              {pedido.quadra.endereco.length > 46
                ? pedido.quadra.endereco.substring(0, 46) + '...'
                : pedido.quadra.endereco}
            </h4>
            {pedido.categoriaEsporte && (
              <Box className='contain-categoria-esporte'>
                <img
                  className='img-categoria-esporte'
                  src={`${pedido.categoriaEsporte.urlFoto}${pedido.categoriaEsporte.foto}`}
                  alt='Categoria Esporte'
                />
                <h3 className='text-categoria-esporte'>{pedido.categoriaEsporte.descricao}</h3>
              </Box>
            )}
          </div>
        </div>
      </div>
    )
  }
}
